import { type ClassValue, clsx } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

// Re-export from centralized error module for backward compatibility
export { getErrorMessage, translateError } from "@/lib/error-messages"